module.exports = __webpack_public_path__ + "img/down-arrow.f94708d8.svg";